import { LinkProps } from 'react-router-dom';
import { StyledLink } from './styles';
import { useAnalytics } from '~/hooks';

export const ExternalLink = ({ children, ...otherProps }: LinkProps) => {
    const { pushEvent } = useAnalytics();

    return (
        <StyledLink
            target="_blank"
            onClick={() => pushEvent({ eventLabel: `${children!.toString()} - link click` })}
            {...otherProps}
        >
            {children}
        </StyledLink>
    );
};
